"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkConditions = void 0;
var _constants = require("./constants");
var handleActionType = (actionType, value) => {
  var actions = {
    [_constants.ACTION_CONTANTS['SHOW']]: () => {
      return !value;
    },
    [_constants.ACTION_CONTANTS['HIDE']]: () => {
      return value;
    }
  };
  return actions[actionType]();
};
var validate = (operator, value, valueAgainst) => {
  if ((value === null || value === undefined) && valueAgainst === "") value = ""; //make sure null and empty string are comparable

  if (Array.isArray(value) && value.length === 0) value = ""; //empty array is same as empty string when comparing value

  if (Array.isArray(value) && value.length === 1) value = value[0]; //single item in array can be equal to string

  if (valueAgainst === 'true' || valueAgainst === 'false') valueAgainst = valueAgainst === 'true' ? true : valueAgainst === 'false' ? false : valueAgainst; // valueAgainst string needs to be converted to boolean if it's coming from a checkbox

  var operators = {
    [_constants.OPERATOR_CONSTANTS['CONTAINS']]: () => {
      var regex = RegExp("".concat(valueAgainst));
      return regex.test(value);
    },
    [_constants.OPERATOR_CONSTANTS['DOES_NOT_CONTAIN']]: () => {
      var regex = RegExp("^((?!".concat(valueAgainst, ").)*$"));
      return regex.test(value);
    },
    [_constants.OPERATOR_CONSTANTS['STARTS_WITH']]: () => {
      var regex = RegExp("^".concat(valueAgainst));
      return regex.test(value);
    },
    [_constants.OPERATOR_CONSTANTS['DOES_NOT_START_WITH']]: () => {
      var regex = RegExp("^(?!".concat(valueAgainst, ").*$"));
      return regex.test(value);
    },
    [_constants.OPERATOR_CONSTANTS['ENDS_WITH']]: () => {
      var regex = RegExp("".concat(valueAgainst, "$"));
      return regex.test(value);
    },
    [_constants.OPERATOR_CONSTANTS['DOES_NOT_END_WITH']]: () => {
      var regex = RegExp("^(.(?!".concat(valueAgainst, "$))+$"));
      if (value === '') {
        // regex fails to test an empty string
        return true;
      }
      return regex.test(value);
    },
    [_constants.OPERATOR_CONSTANTS['IS_EQUAL_TO']]: () => {
      return value === valueAgainst;
    },
    [_constants.OPERATOR_CONSTANTS['IS_NOT_EQUAL_TO']]: () => {
      return value !== valueAgainst;
    },
    [_constants.OPERATOR_CONSTANTS['IS_GREATER_THAN']]: () => {
      return value > valueAgainst;
    },
    [_constants.OPERATOR_CONSTANTS['IS_GREATER_THAN_OR_EQUAL_TO']]: () => {
      return value >= valueAgainst;
    },
    [_constants.OPERATOR_CONSTANTS['IS_LESS_THAN']]: () => {
      return value < valueAgainst;
    },
    [_constants.OPERATOR_CONSTANTS['IS_LESS_THAN_OR_EQUAL_TO']]: () => {
      return value <= valueAgainst;
    }
  };
  if (typeof operators[operator] === 'undefined') return false;
  return operators[operator]();
};
var matchingTypes = (fieldValues, item) => {
  var matches = {
      [_constants.MATCH_TYPE_CONTANTS['ANY']]: (fieldValues, item) => {
        var shouldHide;
        for (var i = 0; i < item.conditions.length; i += 1) {
          var value = fieldValues[item.conditions[i].fieldId],
            operator = item.conditions[i].operatorId,
            valueAgainst = item.conditions[i].value;
          shouldHide = validate(operator, value, valueAgainst);
          if (shouldHide) break;
        }
        return shouldHide;
      },
      [_constants.MATCH_TYPE_CONTANTS['ALL']]: (fieldValues, item) => {
        var shouldHide;
        for (var i = 0; i < item.conditions.length; i += 1) {
          var value = fieldValues[item.conditions[i].fieldId],
            operator = item.conditions[i].operatorId,
            valueAgainst = item.conditions[i].value;
          shouldHide = validate(operator, value, valueAgainst);
          if (!shouldHide) break;
        }
        return shouldHide;
      }
    },
    result = matches[item.matchTypeId](fieldValues, item);
  return handleActionType(item.actionTypeId, result);
};
var checkConditions = (fieldValues, conditions) => {
  var shouldHide;
  for (var i = 0; i < conditions.length; i += 1) {
    shouldHide = matchingTypes(fieldValues, conditions[i]);
    if (shouldHide) break;
  }
  return shouldHide;
};
exports.checkConditions = checkConditions;